import type { NodeEntry, Text } from 'slate';
import { jsx } from 'slate-hyperscript';
import type {
  SerializePayloadHandlerOptions,
  DeserializePayloadHandlerOptions,
  DeserializePayloadValueHandlerOptions,
} from '../../serialize/serialize';
import { SerializePayloadHandler } from '../../serialize/serialize';
import type { LinkElement } from './types';
import { LinkElementType } from './types';
import type { LinkMessageProps } from './components/link-message';
import LinkMessage from './components/link-message';
import { isLinkElement } from './utils';

export class SerializePayloadHandler_link extends SerializePayloadHandler {
  serialize({ editor, entry: [node, path], callback }: SerializePayloadHandlerOptions) {
    const result = editor.above({
      at: path,
      match: isLinkElement as any,
    }) as NodeEntry<LinkElement>;

    if (result) {
      const [{ url }] = result;

      if (url) {
        callback({
          part: (node as Text).text,
          entity: {
            type: LinkElementType,
            url,
          },
        });
      }

      return true;
    }
  }

  deserialize({
    type,
    text,
    entity,
    key,
    props,
  }: DeserializePayloadHandlerOptions<LinkMessageProps>) {
    if (type === LinkElementType) {
      return {
        children: (
          <LinkMessage key={key} href={entity.url} {...props}>
            {text}
          </LinkMessage>
        ),
      };
    }
  }

  deserializeValue({ type, text, entity }: DeserializePayloadValueHandlerOptions) {
    if (type === LinkElementType) {
      return {
        descendant: jsx('element', { type: LinkElementType, href: entity.url }, text),
      };
    }
  }
}
